import React, { PropsWithChildren } from 'react';
import { Paper } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const CardBackground = ({ children }: PropsWithChildren) => {
  const classes = useStyles();

  return (
    <Paper className={classes.paperBg} elevation={0}>
      {children}
    </Paper>
  );
};

const useStyles = makeStyles(theme => ({
  paperBg: {
    padding: '0.5rem 1.5rem',
  },
}));
